import styled, { css } from 'styled-components'

export type CategoriaSectionProps = {
  darkTheme?: boolean
}

export const CategorySection = styled.section<CategoriaSectionProps>`
  width: 100%;
  height: 48px;

  ${({ darkTheme }) =>
    darkTheme &&
    css`
      background-color: #141723 !important;

      span,
      a,
      strong,
      h1,
      h2,
      h3,
      h4,
      button {
        color: #fff !important;
      }
    `}

  @media (max-width: 1200px) {
    display: none;
  }
`

export const CategoryContainer = styled.div`
  position: relative;
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 100%;
  max-width: 1310px;
  width: 100%;
  padding: 0px 15px;
  margin-left: auto;
  margin-right: auto;

  @media (max-width: 1200px) {
    display: none;
  }
`

export const CategoryButton = styled.button<CategoriaSectionProps>`
  display: flex;
  align-items: center;
  height: 48px;
  padding-right: 77px;
  ${({ darkTheme }) =>
    darkTheme
      ? css`
          border-right: 2px solid #0250b5;
        `
      : css`
          border-right: 2px solid #e8e8e8;
        `}
  background-color: transparent;
  img {
    margin-right: 24px;
  }
  span {
    color: #363843;
    font-size: 14px;
  }
`

export const CategoryNav = styled.nav`
  width: 80%;
  ul {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 0;
    li {
      &:hover {
        a {
          font-weight: 500;
        }
      }
      a {
        display: flex;
        align-items: center;
        font-size: 14px;
        color: #363843;
        img {
          margin-right: 11px;
        }
      }
    }
  }
`

export const CategoryDropdown = styled.div<any>`
  position: absolute;
  top: 40px;
  width: calc(100% - 30px);
  height: 463px;
  left: 15px;
  background-color: ${({ darkTheme }) => (darkTheme ? '#141723' : '#fff')};

  ${({ darkTheme }) =>
    darkTheme &&
    css`
      span,
      a,
      strong,
      h1,
      h2,
      h3,
      h4,
      button {
        color: #fff !important;
      }
    `}
  z-index: 6;
  box-shadow: 0px 8px 25px rgba(166, 166, 166, 0.2);
  border-radius: 0px 0px 6px 6px;
  display: grid;
  grid-template-columns: 236px 1fr;
  overflow: hidden;
  opacity: 0;
  pointer-events: none;
  transition: all 0.3s;
  &.active {
    top: 48px;
    opacity: 1;
    pointer-events: all;
    transition: all 0.3s;
  }
  .dir {
    .cont-categoria {
      display: none;
      &.show {
        display: block;
      }

      .info {
        max-width: 533px;
        padding-left: 46px;
        padding-top: 23px;
        h2 {
          font-weight: bold;
          font-size: 18px;
          line-height: 22px;
          letter-spacing: -0.114286px;
          color: #515568;
        }
        .all {
          margin-top: 18px;
          max-height: 380px;
          column-fill: auto;
          column-count: 3;

          h3 {
            font-weight: 500;
            font-size: 14px;
            line-height: 17px;
            letter-spacing: -0.114286px;
            color: #515568;
          }
          .item {
            break-inside: avoid;
            margin-bottom: 20px;
          }
          ul {
            margin-bottom: 25px;
            &:last-child {
              margin-bottom: 0px;
            }
            li {
              margin-bottom: 11px;

              &:last-child {
                margin-bottom: 0px;
              }
              &:hover {
                a {
                  font-weight: 500;
                }
                h3 a {
                  font-weight: 600;
                }
                .item ul li a {
                  font-weight: 400;
                }
              }

              h3 {
                a {
                  font-size: 14px;
                  font-weight: 600;
                }
              }
              a {
                font-size: 13px;
                color: -0.114286px;
                color: #646981;
              }
              .item {
                margin-bottom: 10px;
                ul li {
                  margin-left: 10px;
                  margin-bottom: 5px;

                  &:hover {
                    a {
                      font-weight: 500;
                    }
                  }
                }
              }
            }
          }
        }
      }
      .banner-produto {
        position: absolute;
        top: 0;
        right: 0;
        width: 341px;
        height: 464px;
        border-radius: 0px 0px 6px 0px;
        overflow: hidden;
        display: block;
        a {
          width: 100%;
          display: block;
        }
      }
    }
  }
`

export const CategoryDropdownItemLeft = styled.div<any>`
  padding: 17px 0px 17px 0px;

  border-right: ${({ darkTheme }) =>
    darkTheme ? '2px solid #0250b5' : '2px solid #e8e8e8'};

  ul {
    li {
      margin-bottom: 3px;
      &:last-child {
        margin-bottom: 0px;
      }
      &:hover {
        button,
        a {
          font-weight: 500;
        }
      }
      button,
      a {
        width: 100%;
        padding-left: 30px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        font-size: 13px;
        color: #646981;
        letter-spacing: -0.114286px;
        line-height: 33px;
        padding-right: 16px;
        background-color: transparent;
        transition: all 0.3s;
        outline: none;
        text-decoration: none;
        &:hover {
          ${({ darkTheme }) =>
            darkTheme
              ? css`
                  background-color: #0250b5;
                `
              : css`
                  background-color: #f2f2f2;
                `}
          transition: all 0.3s;
        }
      }
    }
  }
`
